import { render, staticRenderFns } from "./popup-water.vue?vue&type=template&id=44b1ac89&scoped=true"
import script from "./popup-water.vue?vue&type=script&lang=js"
export * from "./popup-water.vue?vue&type=script&lang=js"
import style0 from "./popup-water.vue?vue&type=style&index=0&id=44b1ac89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b1ac89",
  null
  
)

export default component.exports